<div class="table-container">
  @if (data) {
    <p-table [value]="data.data" [scrollable]="true" class="table" class="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>NOME</th>
          <th>E-MAIL</th>
          <th>INGRESSO / LOTE</th>
          <th>QTD. CONVITES</th>
          <th>TRANSFERÍVEL</th>
          <th>DESCRIÇÃO</th>
          <th>STATUS</th>
          @if (!readOnly) {
            <th>AÇÕES</th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invitation let-rowIndex="rowIndex as number">
        <tr>
          <td>{{ invitation.user_name }} {{ invitation.user_last_name }}</td>
          <td>{{ invitation.user_email }}</td>
          <td>{{ invitation.ticket?.title || "Convite de cortesia" }}<br />{{ invitation.ticket?.batch_label || "" }}</td>
          <td>{{ invitation.quantity }}</td>
          <td>{{ invitation.transferable ? "SIM" : "NÃO" }}</td>
          <td>{{ invitation.description }}</td>

          <td>
            <span class="table__status table__status--{{ invitation.status.toLowerCase() }}">
              {{ invitation.status | invitationStatusEnum }}
            </span>
          </td>

          @if (!readOnly) {
            <td>
              @if (invitation.status === invtationStatusEnum.PENDING) {
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editGuestClick.emit(invitation)">
                    <mat-icon>edit</mat-icon>
                    <span>Editar Convite</span>
                  </button>
                  <button mat-menu-item (click)="resendInviteClick.emit(invitation)">
                    <mat-icon>mail</mat-icon>
                    <span>Reenviar Convite</span>
                  </button>
                  <button mat-menu-item (click)="cancelGuestClick.emit(invitation)">
                    <mat-icon>delete</mat-icon>
                    <span>Cancelar Convite</span>
                  </button>
                </mat-menu>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>

    <p-paginator
      (onPageChange)="pageChange.emit($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="data.meta.total_count || 0"
      [showCurrentPageReport]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [rowsPerPageOptions]="[10, 20, 30]"
      currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
  } @else {
    <p-skeleton height="350px" />
  }
</div>
